'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = require('immutable');

var _actions = require('./actions');

/**
 * Translation reducer
 * @param {Map} state Immutable Map
 * @param {Object} action The action dispatched
 * @returns {Map} The new state
 */
var reducer = function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.Map();
    var action = arguments[1];

    if ((0, _actions.isTranslationFetchSucceededAction)(action)) {
        return action.data;
    }

    return state;
};

exports.default = reducer;
//# sourceMappingURL=reducer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/translation-tokens/dist/main/reducer.js
// module id = 538
// module chunks = 0